<template>
    <div class='spinner-container' :style="{height: `${height || 500}px`}">
        <div class='spinner'></div>
        <span v-if='message' class='message'>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',
    props: {
        height: Number,
        message: String,
    }
};
</script>

<style scoped>
.spinner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.spinner {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 5px solid #e0e0e0;
    border-bottom: 5px solid #fe9616;
    animation: spin 1s linear infinite;
    position: relative;
}

.message {
    margin-top: 16px;
    font-size: 20px;
    white-space: pre;
    text-align: center;
    animation: color-change 1s infinite alternate;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@keyframes color-change {
  0% { opacity: 0.2; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
}
</style>
